import React from 'react';
import { ArrowRightIcon, Building2Icon, MapPinIcon } from 'lucide-react';
import { ImageSourceBadge } from '../ui/ImageSourceBadge';
import { useProjectDrawer } from '../../contexts/ProjectDrawerContext';
import { categoryLabel } from '../../utils/projects';
import type { Project } from '../../types/content';
export function ProjectCard({
  project
}: {
  project: Project;
}) {
  const {
    openProject
  } = useProjectDrawer();
  const cover = project.images[0];
  return <article className="group flex h-full flex-col bg-charcoal-900 ring-1 ring-white/10" data-id="element-431" data-mp="1438qh2wbjpoz">
      <button type="button" tabIndex={-1} aria-hidden="true" onClick={event => openProject(project.id, event.currentTarget)} className="relative block aspect-[4/3] overflow-hidden" data-id="element-432" data-mp="145lgm3c8d6d4">
        <img src={cover.src} alt={cover.alt} loading="lazy" decoding="async" className="h-full w-full object-cover transition-transform duration-300 ease-out group-hover:scale-[1.03]" data-id="element-433" data-mp="2thnko2q3w4rv" />
        <span className="absolute left-0 top-4 bg-brand-action px-3 py-1 font-display text-[13px] font-bold uppercase tracking-[0.12em] text-white" data-id="element-434" data-mp="29ck6kq04o9mg">
          {categoryLabel(project.category)}
        </span>
        <ImageSourceBadge source={cover.source} className="absolute bottom-3 right-3" data-id="element-435" data-mp="2j8wz3kjxshfm" />
      </button>

      <div className="flex flex-1 flex-col p-6" data-id="element-436" data-mp="2o80454zx2nnl">
        <h3 className="font-display text-[24px] font-bold uppercase leading-[1.02] text-white" data-id="element-437" data-mp="1qn3tz4b64qpo">{project.title}</h3>
        <dl className="mt-4 space-y-1.5 text-sm text-steel-300" data-id="element-438" data-mp="1vm6zsqyz30yp">
          {project.location && <div className="flex gap-2" data-id="element-439" data-mp="20jqcvnjxp7p2">
              <dt className="sr-only" data-id="element-440" data-mp="20inlzfmm3595">Location</dt>
              <MapPinIcon className="mt-0.5 h-4 w-4 shrink-0 text-brand-light" aria-hidden="true" data-id="element-441" data-mp="25c9z18wotb5h" />
              <dd data-id="element-442" data-mp="17urq2d4v9hdf">{project.location}</dd>
            </div>}
          {project.client && <div className="flex gap-2" data-id="element-443" data-mp="1ctmkydg3ywdw">
              <dt className="sr-only" data-id="element-444" data-mp="1cskzdf1gurhx">Client</dt>
              <Building2Icon className="mt-0.5 h-4 w-4 shrink-0 text-brand-light" aria-hidden="true" data-id="element-445" data-mp="14t6jd6ei99do" />
              <dd className="line-clamp-1" data-id="element-446" data-mp="zu3lc5wy03f7">{project.client}</dd>
            </div>}
        </dl>
        <p className="mt-4 line-clamp-3 text-[15px] leading-relaxed text-steel-300" data-id="element-447" data-mp="1eiq3efdyf9a4">{project.summary}</p>

        <div className="mt-auto pt-6" data-id="element-448" data-mp="19lggp7hy9bpz">
          <div className="flex items-center justify-between gap-4 border-t border-white/10 pt-5" data-id="element-449" data-mp="lvdrr09c0lvl">
            <span className="line-clamp-1 text-[13px] uppercase tracking-[0.08em] text-steel-400" data-id="element-450" data-mp="gwal5bdpe7li">
              {project.status ?? project.period ?? ''}
            </span>
            <button type="button" onClick={event => openProject(project.id, event.currentTarget)} aria-label={`View project: ${project.title}`} className="inline-flex shrink-0 items-center gap-2 font-display text-[15px] font-bold uppercase tracking-[0.08em] text-brand-light transition-colors duration-150 hover:text-white" data-id="element-451" data-mp="vuuvvd8xqrpg">
              View Project
              <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-452" data-mp="2es7ww60k42ge" />
            </button>
          </div>
        </div>
      </div>
    </article>;
}